<template>
  <div>
    <v-expansion-panels v-model="activePanel" elevation="0">
      <v-expansion-panel elevation="0">
        <v-expansion-panel-header style="padding: 35px;">
          <h3 style="color: #42352e">Búsqueda detallada</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-form ref="form" v-model="isFormValid" lazy-validation>
            <v-row dense>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.nombre"
                  label="Nombre"
                  outlined
                  dense
                  background-color="white"
                  color="#b11f1f"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.apellidoPaterno"
                  label="Apellido Paterno"
                  outlined
                  dense
                  background-color="white"
                  color="#b11f1f"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.apellidoMaterno"
                  label="Apellido Materno"
                  outlined
                  dense
                  background-color="white"
                  color="#b11f1f"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.correo"
                  label="Correo Electrónico"
                  outlined
                  dense
                  background-color="white"
                  color="#b11f1f"
                />
              </v-col>
              <v-col cols="6" md="2">
                <v-select
                  v-model="form.status"
                  :items="statuslist"
                  item-value="id"
                  item-text="nombre"
                  label="Estatus"
                  color="#b11f1f"
                  outlined
                  background-color="white"
                  dense
                />
              </v-col>
              <v-col cols="6" md="2">
                <v-select
                  v-model="form.rol"
                  :items="rolesPermitidos"
                  item-value="id"
                  item-text="rol"
                  label="Rol"
                  color="#b11f1f"
                  outlined
                  background-color="white"
                  dense
                />
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-container fluid>
      <v-row class="d-flex justify-end">
        <v-col cols="12" md="3" class="d-flex justify-end my-8">
          <v-btn
            dark
            outlined
            color="#cc092f"
            rounded
            class="mr-2"
            min-width="120"
            @click="clearForm()"
          >
            Limpiar filtros
          </v-btn>
          <v-btn
            class="common-botton"
            color="#cc092f"
            dark
            min-width="120"
            :disabled="!isFormValid || !minimoUnCampoLleno || loading"
            :loading="loading"
            @click="updateSearch"
          >
            Buscar
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    currentFilters: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: true,
    },
     rolesPermitidos: {
      type: Array,
      default: () => [],
     },
  },
  data() {
    return {
      form: {
        nombre: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        email: "",
        status: "",
        rol: "",
      },
      statuslist: [
        { id: -1, nombre: "Baja" },
        { id: 0, nombre: "Nuevo" },
        { id: 1, nombre: "Activo" },
        { id: 2, nombre: "Inactivo" }
      ],
   };
  },

  computed: {
    minimoUnCampoLleno() {
      return Object.keys(this.form).some((key) => {
        const value = this.form[key];

        if (Array.isArray(value)) {
          return value.length > 0;
        }

        return value !== "" && value !== null && value !== undefined;
      });
    },
  },

  methods: {
    clearForm() {
      Object.keys(this.form).forEach((key) => {
        this.form[key] = "";
      });
      //   this.form.status = 0;
    },


    updateSearch() {
      if (!this.isFormValid || !this.minimoUnCampoLleno) return;
      let payload = {};
      Object.keys(this.form).forEach((key) => {
        const value = this.form[key];

        // campos vacíos no
        if (value === "" || value === null || value === undefined) return;

        // arreglos vacíos
        if (Array.isArray(value) && value.length === 0) return;

        payload[key] = value;
      });


      this.$emit("searchUpdated", payload);
    },

    setCurrent() {
      this.clearForm();
      this.form = { ...this.form, ...this.currentFilters };
    },
  },
};
</script>

<style scoped>
.v-expansion-panel {
  border-radius: 20px;
}
.v-expansion-panels {
  z-index: auto !important;
}
.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)
  > .v-expansion-panel--active {
  border-radius: 20px !important;
  background-color: #f7f8fa;
}
.v-expansion-panel-header {
  background-color: #f7f8fa;
  border-radius: 20px !important;
}
.botones-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-around;
  margin-bottom: 20px;
}

.stats-button {
  width: 300px;
  height: 40px !important;
  font-size: small;
  font-weight: bold;
  margin-top: 10px;
}
</style>